<script setup lang="ts">
import { useMessagesStore } from '@/stores/message.store'

const messages = useMessagesStore()
</script>

<template>
  <RouterView />
  <v-snackbar-queue v-model="messages.queue" class="app-snackbar-queue" location="bottom center">
    <template #text="{ item }">
      <div class="d-flex align-center">
        <v-icon v-if="item.icon" :icon="item.icon" class="me-2" />
        <span class="app-snackbar-queue__text">{{ item.text }}</span>
      </div>
    </template>
  </v-snackbar-queue>
</template>
